import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AuthContext } from "../context/AuthContext";
import { Form, Button, FloatingLabel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Capacitor } from "@capacitor/core";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Keyboard } from "@capacitor/keyboard";
// import logo from "../assets/images/logo_albero_green.png";
import logo from "../assets/images/ti pianto per amore-APP-verde.png";
// import { SiStreamrunners } from "react-icons/si";
import { GrUndo } from "react-icons/gr";
import { toast } from "react-toastify";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa6";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import Google from "../components/registration/Google";
import Terms from "../components/registration/Terms";
import { VersionContext } from "../context/VersionContext";
import Loading from "./Loading";

const AuthForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    setUserRole,
    setIsRegister,
    isRegister,
    login,
    setLogReg,
    setIsAuthenticated,
    loading,
    getCities,
    cities,
    generateFiscalCode,
    validateFiscalCode: checkFiscalCode,
  } = useContext(AuthContext);
  const { version } = useContext(VersionContext);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    watch,
    clearErrors,
  } = useForm();
  const [serverError, setServerError] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();

  const fields = watch();
  const { name, lastName, gender, city, birthday } = fields;
  useEffect(() => {
    version();
    if (name && lastName && gender && city && birthday) {
      console.log("12321", name);
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [name, lastName, gender, city, birthday]);

  useEffect(() => {
    getCities();
  }, []);

  const validateFiscalCode = async (cf) => {
    const response = await checkFiscalCode(cf);
    if (response === "Codice fiscale valido") {
      console.log("Codice fiscale valido");
      return true;
    }
    console.log("errore codice fiscale:", response);
    return false;
  };

  // const onSubmit = async (data) => {
  //   setLoading(true);
  //   if (isRegister) {
  //     console.log("aooooooooooooo");
  //     const isValid = await validateFiscalCode(data.fiscalCode);
  //     if (!isValid) {
  //       setLoading(false);
  //       return;
  //     }
  //   }

  //   try {
  //     const response = await login(data);
  //     console.log("here1", response);
  //     if (response.status === 201 || response.status === 200) {
  //       setIsAuthenticated(true);
  //       setLogReg(false);
  //       localStorage.setItem("justLoggedIn", "true");
  //       navigate("/map");

  //       const {
  //         token,
  //         user: { role },
  //       } = response.data;
  //       console.log("here2", role);

  //       setUserRole(role);

  //       localStorage.setItem("userToken", token);
  //     }
  //   } catch (error) {
  //     console.log("here3", error);
  //     let message = error.response?.data?.message || "Server error";

  //     toast.error(`${message}`, {
  //       position: "top-right",
  //       autoClose: 3000,
  //       hideProgressBar: false,
  //       closeOnClick: false,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //       // transition: Bounce,
  //     });
  //     setServerError(message);
  //     setTimeout(() => {
  //       setServerError("");
  //     }, 3000); // Clear error message after 3 seconds
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <Container className='d-flex flex-column justify-content-center py-5'>
      {loading && <Loading />}
      <div className='logo-container ms-auto me-auto mt-5'>
        <img src={logo} class='img-fluid' alt='Responsive image'></img>
      </div>

      <Row className='d-flex justify-content-center mt-3'>
        <article className='col-xs-8 col-sm-7 col-lg-6 access-container p-2 p-lg-5'>
          <Button
            className='d-block w-100 mb-3'
            variant='primary'
            disabled={loading}
            onClick={() => navigate("/login-form")}
          >
            Effettua il login
          </Button>
          <Button
            className='d-block w-100 mb-3'
            variant='primary'
            disabled={loading}
            onClick={() => navigate("/register")}
          >
            Registrati
          </Button>

          {Capacitor.getPlatform() === "web" && (
            <Button
              className='d-block w-100 my-3'
              variant='primary'
              disabled={loading}
              onClick={() => navigate("/")}
            >
              Continua senza accedere
            </Button>
          )}
          <div className='separator-external mb-3'></div>
          <Google />
          {Capacitor.getPlatform() === "web" && (
            <a
              className='btn btn-outline-secondary d-block w-100 mt-3'
              variant='primary'
              disabled={loading}
              href='https://play.google.com/store/apps/details?id=com.piantala.app'
            >
              <div className='d-flex align-items-center justify-content-center'>
                <FaGooglePlay />
                <span className='ps-2'>Scarica l'app da Google Play</span>
              </div>
            </a>
          )}
        </article>

        <Terms />
      </Row>
    </Container>
  );
};

export default AuthForm;
